import { getCardKey } from '../DeckState';
import { ExodusCard } from '../types/ExodusCard';
import { ExodusCardsJson } from './ExodusCards';
export const IDedExodusCards: Map<string, ExodusCard> = new Map(
  ExodusCardsJson.map((c) => [getCardKey(c), c])
);
